module.exports = __webpack_public_path__ + "static/media/logo.4642ba73.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/logo.png
// module id = 217
// module chunks = 0